const stripNewLines = value => value && value.replace(/\n/g, '');

export const post = {
  title: stripNewLines,
};

export const category = {
  label: stripNewLines,
  description: stripNewLines,
};



// WEBPACK FOOTER //
// ./app/services/form-normalizers.js